import { configureStore } from '@reduxjs/toolkit'
import { combineReducers } from '@reduxjs/toolkit'
import siteReducer from './slices/siteSlice'

const rootReducer = combineReducers({
    sites:siteReducer
})

export const store = configureStore({
  reducer: rootReducer,
})